<script lang="ts" setup>
export interface PagesAssistenceServicesBenefitHeadingProps {
    subtitle: string
    productsList: string
}

const props = defineProps<PagesAssistenceServicesBenefitHeadingProps>()
</script>
<template>
  <Box
    class="text-center"
    color="green"
    padding="px-2 py-10 py-lg-15 px-5 px-lg-10"
  >
    <p class="fw-normal mb-1 delta">
      {{ props.subtitle }}
      <br>
      <span class="mb-0 delta d-block">{{ props.productsList }}</span>
    </p>
  </Box>
</template>
